export default __webpack_public_path__ + "static/media/notifications.605730ae.svg";